// bao migrate skip
import "./../../bindings/bao-upload";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/validate";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import * as $ from "jquery";
import BaoDialog from "./../../factories/bao-dialog";
import * as moment from "moment";
class ConfigurationItem250BillingPlanDialog {
    public Description: KnockoutObservable<string>;
    public AccountAssignmentTypeId: KnockoutObservable<string>;
    public AccountAssignmentTypeName: KnockoutObservable<string>;
    public AccountAssignment: KnockoutObservable<string>;
    public SalesDateJs: KnockoutObservable<string>;
    public Sales: KnockoutObservable<any>;
    public Progress: KnockoutObservable<any>;
    public IsDone: KnockoutObservable<string>;
    public Remark: KnockoutObservable<string>;
    public SearcherAccountAssignmentType: Bindings.baoSearcher;
    public DescriptionValidate: Bindings.validate;
    public BindingSales: Bindings.baoNumberBox;
    public BindingProgress: Bindings.baoNumberBox;
    Dialog: BaoDialog;
    constructor(data: any, dialog: BaoDialog) {
        this.Dialog = dialog;
        this.Dialog.Width("800px");
        $.extend(this, data);
        //TODO: schöner Machen! Anpassung in dialog notwendig. Vermutlich über neuen Dialog (baoDialog2)
        data.Parent.ItemCompleteCheck = this.ItemCompleteCheck;
        this.DescriptionValidate = {
            value: this.Description,
            type: 'required'
        };
        this.SearcherAccountAssignmentType = {
            ObjectId: this.AccountAssignmentTypeId,
            ObjectValue: 'AccountAssignmentType',
            SearchType: 'AccountAssignmentType',
            AutoSearch: true,
            AutoComplete: true,
            AutoCompleteOpts: { preselect: false }
        };
        this.BindingSales = {
            value: this.Sales,
            culture: Bao.Session.Language.Symbol(),
            decimalDigits: 2,
            thousandSeperator: true
        };
        this.BindingProgress = {
            value: this.Progress,
            culture: Bao.Session.Language.Symbol(),
            decimalDigits: 0,
            thousandSeperator: false
        };
    }
    ItemCompleteCheck = (item: any): JQueryPromise<boolean> => {
        let def = $.Deferred<boolean>();
        let result = this.validate();
        def.resolve(result);
        return def.promise();
    };
    public validate: () => boolean;
    public CompleteCheck(): boolean {
        var isCompleted = this.validate();
        if (!isCompleted) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isCompleted;
    }
}
export default ConfigurationItem250BillingPlanDialog;